import { render, staticRenderFns } from "./entry-info-more.vue?vue&type=template&id=5634d0da&scoped=true&"
import script from "./entry-info-more.vue?vue&type=script&lang=js&"
export * from "./entry-info-more.vue?vue&type=script&lang=js&"
import style0 from "./entry-info-more.vue?vue&type=style&index=0&id=5634d0da&prod&lang=scss&scoped=true&"
import style1 from "./entry-info-more.vue?vue&type=style&index=1&id=5634d0da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634d0da",
  null
  
)

export default component.exports